import React, { useState } from "react"
import { ErrorMessage, Field, Form, Formik } from "lib/formik"
import { Button, Col, Label, Row } from "reactstrap"
import { userResetPasswordSchema } from "components/Common/validation"
import { patch } from "helpers/api_helper"
import { useNavigate } from "react-router-dom"
import { showAlert } from "store/reducers/alertReducer"
import { UPDATE_USER_PASSWORD } from "helpers/url_helper"
import { useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"
import TextError from "components/Shared/TextError"

const initialValues = {
  password: "",
  newPassword: "",
  confirmPassword: "",
}

const CommonChangePassword = () => {
  const { t } = useTranslation()

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)
  const [showPassword, setShowPassword] = useState({
    password: false,
    newPassword: false,
    confirmPassword: false,
  })

  const handleOnSubmit = async (values, { resetForm }) => {
    setIsLoading(true)
    const { password, newPassword, confirmPassword } = values
    const payload = {
      password,
      newPassword,
      confirmPassword,
    }
    const result = await patch(UPDATE_USER_PASSWORD, payload)
    if (result) {
      setIsLoading(false)
      if (result?.statusCode === 200 && result?.status) {
        resetForm()
        dispatch(showAlert({ text: result.msg, type: "success" }))
        navigate("/logout")
      } else {
        dispatch(showAlert({ text: result.msg, type: "error" }))
      }
    }
  }

  const togglePasswordVisibility = field => {
    setShowPassword(prevState => ({
      ...prevState,
      [field]: !prevState[field],
    }))
  }

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={userResetPasswordSchema}
      onSubmit={handleOnSubmit}
    >
      {({ errors, touched, isSubmitting }) => (
        <Form>
          <Row className="mb-2">
            <Col md={12}>
              <div className="form_field">
                <Label htmlFor="password" className="col col-form-label">
                  {t("Current Password")}
                </Label>
                <div className="position-relative">
                  <Field
                    name="password"
                    type={showPassword.password ? "text" : "password"}
                    id="password"
                    placeholder={t("Current Password")}
                    className={`form-control ${
                      touched.password && errors.password ? "is-invalid" : ""
                    }`}
                  />
                  <i
                    onClick={() => togglePasswordVisibility("password")}
                    className={`bx bx-${
                      showPassword.password ? "show-alt" : "hide"
                    } common_eye`}
                  ></i>
                </div>
                <TextError name="password" />
              </div>
            </Col>
            <Col md={12}>
              <div className="form_field">
                <Label htmlFor="newPassword" className="col col-form-label">
                  {t("New Password")}
                </Label>
                <div className="position-relative">
                  <Field
                    name="newPassword"
                    type={showPassword.newPassword ? "text" : "password"}
                    id="newPassword"
                    placeholder={t("New Password")}
                    className={`form-control ${
                      touched.newPassword && errors.newPassword
                        ? "is-invalid"
                        : ""
                    }`}
                  />
                  <i
                    onClick={() => togglePasswordVisibility("newPassword")}
                    className={`bx bx-${
                      showPassword.newPassword ? "show-alt" : "hide"
                    } common_eye`}
                  ></i>
                </div>
                <TextError name="newPassword" />
              </div>
            </Col>
            <Col md={12}>
              <div className="form_field">
                <Label htmlFor="confirmPassword" className="col col-form-label">
                  {t("Confirm Password")}
                </Label>
                <div className="position-relative">
                  <Field
                    name="confirmPassword"
                    type={showPassword.confirmPassword ? "text" : "password"}
                    id="confirmPassword"
                    placeholder={t("Confirm Password")}
                    className={`form-control ${
                      touched.confirmPassword && errors.confirmPassword
                        ? "is-invalid"
                        : ""
                    }`}
                  />
                  <i
                    onClick={() => togglePasswordVisibility("confirmPassword")}
                    className={`bx bx-${
                      showPassword.confirmPassword ? "show-alt" : "hide"
                    } common_eye`}
                  ></i>
                </div>
                <TextError name="confirmPassword" />
              </div>
            </Col>
            <Col sm={12}>
              <div className="d-flex justify-content-end mt-4">
                <Button
                  type="button"
                  color="secondary"
                  onClick={() => navigate(-1)}
                >
                  {t("Cancel")}
                </Button>
                <Button
                  className="mx-2"
                  type="submit"
                  color="success"
                  disabled={isLoading}
                >
                  {t("Save")}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  )
}

export default CommonChangePassword
